import * as React from 'react';
import styles from './SantaPage.scss';
import { IPromoPage } from '~/Layouts/Themes/GroupingPage/GroupingPage';
import { groupBundlesByName } from '~/utils/bundles';
import SantaBundle from '~/Layouts/Themes/SantaPage/SantaBundle/SantaBundle';
import SantaShowcaseSwitcher from '~/components/SantaShowcaseSwitcher/SantaShowcaseSwitcher';

const SantaPage = (props: IPromoPage) => {
    const groups = groupBundlesByName(props.bundles);
    const refs = React.useRef<Map<string, HTMLDivElement>>(new Map<string, HTMLDivElement>());

    const [selectedBundle, setSelectedBundle] = React.useState<{ group?: string; index?: number; group_index?: number }>({
        group: null,
        index: null,
        group_index: 0,
    });

    const allNames = Object.keys(groups);

    return (
        <>
            <div className={styles.wrapper}>
                <SantaShowcaseSwitcher className={styles.mobileSwitcher} />
                <div className={styles.content}>
                    {allNames.map((group: string, index) => {
                        return (
                            <SantaBundle
                                groupName={group}
                                groups={groups}
                                key={group}
                                selectedGroup={selectedBundle.group}
                                selectedIndex={selectedBundle.index}
                                isLastGroup={index === allNames.length - 1}
                                ref={(ref: HTMLDivElement) => {
                                    if (ref) {
                                        refs.current.set(group, ref);
                                    }
                                }}
                            />
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default SantaPage;
